import * as React from 'react';
import { SVGProps } from 'react';

const SvgDangerFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-.906-9.239a.848.848 0 0 0 1.688.016l.559-5.272a1.362 1.362 0 1 0-2.71-.024l.463 5.28Zm.812 2.631a1.304 1.304 0 1 0 0 2.608h.038a1.304 1.304 0 0 0 0-2.608h-.038Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDangerFilled;
